firebird.controller('meetingFullCtrl', [
    '$stateParams',
    'meetingService',
    'supportLinkService',
    'localizationService',
    function ($stateParams, meetingService, supportLinkService, localizationService) {
        var self = this;

        self.meetingCode = '';
        self.meetingType = '';
        self.dialInNumber = '';
        self.dialInPin = '';
        self.maxUsers = 0;
        self.getAppLogoURL = meetingService.getAppLogoURL;
        self.title = '';

        self.getSupportLink = getSupportLink;
        self.onSupportLinkClick = onSupportLinkClick;

        init();

        ////////////////////////

        function init() {
            var seats = $stateParams.seats || '0';
            self.maxUsers = seats;
            self.meetingIsFullMessage = 'looks like this meeting is super popular';
            self.meetingType = meetingService.getMeetingType();
            self.dialInNumber = $stateParams.phoneNumber;
            self.dialInPin = $stateParams.pin;

            self.title =
                self.meetingType == 'meeting'
                    ? localizationService.translate('LOBBY_PAGE.ONLINE_MEETING_FULL')
                    : localizationService.translate('LOBBY_PAGE.WEBINAR_FULL');
        }

        function getSupportLink() {
            return supportLinkService.getSupportLink('portalsEmailNew');
        }

        function onSupportLinkClick() {
            meetingService.openExternalLink(supportLinkService.getSupportLink('portalsEmailNew'));
        }
    }
]);
